import React from "react";
import { Instagram, Youtube, Mail, ArrowUpRight } from "lucide-react";
import { APPLY_URL } from "../../data/mock";

export default function Footer() {
  return (
    <footer className="relative border-t hairline pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
          <div>
            <div className="flex items-baseline gap-3">
              <div className="font-display text-[46px] leading-none">27:17</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--text-muted)]">Performance</div>
            </div>
            <p className="font-display italic text-[22px] text-[var(--ember-3)] mt-6">Train Hard · Lead Well · Perform for Him</p>
            <p className="mt-6 max-w-[380px] text-[var(--text-muted)] text-[14.5px] leading-[1.75]">A covenant coaching brotherhood for Christian men. Body, heart, mind, home — forged together.</p>
          </div>

          <FooterCol title="Explore" links={[{l:"The Word",h:"#word"},{l:"Four Pillars",h:"#pillars"},{l:"Inside",h:"#inside"},{l:"Process",h:"#process"}]} />
          <FooterCol title="Company" links={[{l:"The Coach",h:"#coach"},{l:"FAQ",h:"#faq"},{l:"Forged Plate",h:"#forged-plate"},{l:"Contact",h:"mailto:hello@2717.co"}]} />
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] mb-5">Follow</div>
            <div className="flex gap-3">
              {[{I:Instagram, l:"IG"},{I:Youtube, l:"YT"},{I:Mail, l:"Mail"}].map(({I, l},i)=>(
                <a key={i} href="#" aria-label={l} className="w-10 h-10 border hairline-2 flex items-center justify-center hover:border-[var(--ember-2)] hover:text-[var(--ember-2)] transition-colors"><I size={16}/></a>
              ))}
            </div>
            <a href={APPLY_URL} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-[var(--text)] hover:text-[var(--ember-2)] transition-colors">Apply <ArrowUpRight size={14}/></a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t hairline flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-[var(--text-dim)]">© {new Date().getFullYear()} 27:17 Performance. All rights reserved.</div>
          <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-[var(--text-dim)]">Prov. 27:17 · As iron sharpens iron</div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] mb-5">{title}</div>
      <ul className="space-y-3">
        {links.map((l,i)=>(
          <li key={i}><a href={l.h} className="text-[15px] text-[var(--text)] hover:text-[var(--ember-2)] transition-colors">{l.l}</a></li>
        ))}
      </ul>
    </div>
  );
}
